import { REQUEST_METHOD } from 'utils/apiClient'
import { APIRoute } from 'routes/api'
import { createApiThunk } from 'utils/thunkWrapper'

export const getAdminUsers = createApiThunk<User[], void>({
  action: 'administrators/get',
  method: REQUEST_METHOD.GET,
  formatUrl: () => APIRoute.GET_ADMIN_USERS,
})

export const updateAdminUser = createApiThunk<User, UpdateAdminUserPayload>({
  action: 'administrators/updateUser',
  method: REQUEST_METHOD.POST,
  formatUrl: (payload) => APIRoute.PUT_UPDATE_ADMIN_USER(payload.id),
  getData: (payload) => payload.data,
  getSuccessMessage: (payload) => payload.successMessage,
})

export const deleteAdminUser = createApiThunk<void, DeleteAdminUserPayload>({
  action: 'administrators/deleteUser',
  method: REQUEST_METHOD.DELETE,
  formatUrl: (payload) => APIRoute.DELETE_ADMIN_FROM_USER(payload.id),
  getSuccessMessage: (payload) => payload.successMessage,
})

export const resetMfaForAdminUser = createApiThunk<User, ResetAdminUserMfaPayload>({
  action: 'administrators/resetUserMfa',
  method: REQUEST_METHOD.POST,
  formatUrl: (payload) => APIRoute.POST_RESET_MFA_FOR_ADMIN_USER(payload.id),
  getSuccessMessage: (payload) => payload.successMessage,
})
